<div
  class="flex flex-1 items-center justify-center rounded-full p-2"
  [ngClass]="{
    'bg-slate-300': !active,
    'bg-slate-800': active
  }"
  [ngStyle]="{ 'width.px': size, 'height.px': size }"
>
  <span
    class="select-none"
    [ngClass]="{
      'text-slate-900': !active,
      'text-slate-300': active
    }"
    [ngStyle]="{ 'font-size': applySizeToFont ? size + 'px' : null }"
    >{{ display }}</span
  >
</div>
